<template>
    <b-row>
        <b-col>
            <ListadoPrecios />
        </b-col>
        <b-col cols="12">
            <ConfigurarPreciosParcelas />
        </b-col>
    </b-row>
</template>

<script>
    import ListadoPrecios from '@/components/backend/parcelas/ListadoPrecios';
    import ConfigurarPreciosParcelas from '@/components/backend/parcelas/ConfigurarPreciosParcelas';

    export default {
        components: {
            ListadoPrecios, ConfigurarPreciosParcelas
        }
    }
</script>
